import { activationApi } from "@/api/setup";
import { IGetFrontendConfigResponse } from "@/types/api/site";
import { FeatureFlag } from "@/types/enum";

export const getFeatureFlag = (): Promise<Record<FeatureFlag, boolean>> =>
    activationApi.get("/site/feature-flags");

export const getFrontendConfig = (): Promise<IGetFrontendConfigResponse> =>
    activationApi.get("/site/frontend-config");
